// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Nanoid from "nanoid";
import * as Belt_List from "../../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as SlabsTable from "../../sidebars/SlabsTable.bs.js";
import * as Caml_option from "../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as ReactModal from "react-modal";
import * as Row$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CorePricingContext from "../../../library/core-pricing-context/CorePricingContext.bs.js";
import * as ListUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ListUtils.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as ModificationActions from "../../../vm-mapper/ModificationActions.bs.js";
import * as AccordionV2$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/AccordionV2.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as CorePricingViewUtils from "../../../library/utils/CorePricingViewUtils.bs.js";
import * as EligibilityRulesCard from "./EligibilityRulesCard.bs.js";
import * as ModificationStatusVm from "../../../vm-mapper/ModificationStatusVm.bs.js";
import * as CardComponent$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as AccordionTypes$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/AccordionTypes.bs.js";
import * as VehicleGeoRegionTitleBar from "../../sidebars/core-pricing/VehicleGeoRegionTitleBar.bs.js";
import * as ModificationActionManager from "../../../library/ModificationActionManager.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";
import * as ModificationBaseDetailsCard from "./ModificationBaseDetailsCard.bs.js";
import * as PricingDashboardAssetsManager from "../../../../assets/PricingDashboardAssetsManager.bs.js";

var close_icon = PricingDashboardAssetsManager.getImage("close-icon.svg");

function convertIdListToRange(ids) {
  var sortedIds = Belt_List.sort(ids, (function (a, b) {
          return a - b | 0;
        }));
  var startId = String(Belt_List.headExn(sortedIds));
  var endOd = String(Belt_List.getExn(sortedIds, Belt_List.length(sortedIds) - 1 | 0));
  return startId + "-" + endOd;
}

function testIdsToString(a) {
  return ListUtils$Catalyst.toString(a, (function (a) {
                return String(a);
              }), undefined, undefined);
}

function getAccordionHeaderForTestSample(index, test_ids) {
  return React.createElement("div", undefined, "Test " + String(index + 1 | 0) + " ( id: " + convertIdListToRange(test_ids) + " )");
}

function ModificationDetailModal$BaseDetailsSection(Props) {
  var base_details = Props.base_details;
  var tmp;
  tmp = base_details.TAG === /* AB */0 ? React.createElement(React.Fragment, undefined, $$Array.mapi((function (index, test_info) {
                return React.createElement(AccordionV2$Catalyst.make, {
                            panels: {
                              hd: AccordionTypes$Catalyst.make_props({
                                    TAG: /* Custom */1,
                                    _0: (function (param) {
                                        return getAccordionHeaderForTestSample(index, test_info.test_ids);
                                      })
                                  }, undefined, undefined, React.createElement(ModificationBaseDetailsCard.make, {
                                        base_details: test_info.test_details
                                      }), undefined),
                              tl: /* [] */0
                            },
                            defaultOpen: index === 0 ? 0 : -1
                          });
              }), $$Array.of_list(base_details.test_detail_and_ids)), React.createElement(AccordionV2$Catalyst.make, {
              panels: {
                hd: AccordionTypes$Catalyst.make_props({
                      TAG: /* Text */0,
                      _0: "Control"
                    }, undefined, undefined, React.createElement(ModificationBaseDetailsCard.make, {
                          base_details: base_details.control_details
                        }), undefined),
                tl: /* [] */0
              },
              defaultOpen: -1
            })) : React.createElement(ModificationBaseDetailsCard.make, {
          base_details: base_details._0
        });
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "card-title"
                }, "BASE DETAILS"), tmp);
}

var BaseDetailsSection = {
  make: ModificationDetailModal$BaseDetailsSection
};

function ModificationDetailModal$SlabDetailsSection(Props) {
  var slabs = Props.slabs;
  var tmp;
  tmp = slabs.TAG === /* AB */0 ? React.createElement(React.Fragment, undefined, $$Array.mapi((function (index, test_info) {
                return React.createElement(AccordionV2$Catalyst.make, {
                            panels: {
                              hd: AccordionTypes$Catalyst.make_props({
                                    TAG: /* Custom */1,
                                    _0: (function (param) {
                                        return getAccordionHeaderForTestSample(index, test_info.test_ids);
                                      })
                                  }, undefined, undefined, React.createElement(CardComponent$Catalyst.make, {
                                        className: "modification-basic-primary-info-card",
                                        children: React.createElement(SlabsTable.make, {
                                              slabs: test_info.test_details
                                            })
                                      }), undefined),
                              tl: /* [] */0
                            },
                            defaultOpen: index === 0 ? 0 : -1
                          });
              }), $$Array.of_list(slabs.test_slab_and_ids)), React.createElement(AccordionV2$Catalyst.make, {
              panels: {
                hd: AccordionTypes$Catalyst.make_props({
                      TAG: /* Text */0,
                      _0: "Control"
                    }, undefined, undefined, React.createElement(CardComponent$Catalyst.make, {
                          className: "modification-basic-primary-info-card",
                          children: React.createElement(SlabsTable.make, {
                                slabs: slabs.control_details
                              })
                        }), undefined),
                tl: /* [] */0
              },
              defaultOpen: -1
            })) : React.createElement(CardComponent$Catalyst.make, {
          className: "modification-basic-primary-info-card",
          children: React.createElement(SlabsTable.make, {
                slabs: slabs._0
              })
        });
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "card-title"
                }, "SLAB DETAILS"), tmp);
}

var SlabDetailsSection = {
  make: ModificationDetailModal$SlabDetailsSection
};

function ModificationDetailModal(Props) {
  var modification = Props.modification;
  var take_action_cb = Props.take_action_cb;
  var close_modal = Props.close_modal;
  var is_action_allowed = Props.is_action_allowed;
  var match = CorePricingContext.useContext(undefined);
  var allowed_actions = is_action_allowed ? ModificationActionManager.getActionsByRoleAndStatus(match.role, modification.status) : /* [] */0;
  var match$1 = modification.status;
  var end_date = modification.end_date;
  var tmp;
  if (allowed_actions) {
    var match$2 = allowed_actions.tl;
    var a = allowed_actions.hd;
    if (match$2) {
      if (match$2.tl) {
        tmp = null;
      } else {
        var b = match$2.hd;
        tmp = ReasonReactUtils$Catalyst.listToReactArray({
              hd: React.createElement(PrimaryButton$Catalyst.make, {
                    buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                          TAG: /* Text */0,
                          _0: ModificationActions.toString(a)
                        }, undefined, (function (param) {
                            return Curry._2(take_action_cb, modification.external_id, a);
                          }), undefined, undefined, undefined, undefined, "c-mui-primary-back-btn", undefined, undefined),
                    key: Nanoid.nanoid()
                  }),
              tl: {
                hd: React.createElement(PrimaryButton$Catalyst.make, {
                      buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                            TAG: /* Text */0,
                            _0: ModificationActions.toString(b)
                          }, undefined, (function (param) {
                              return Curry._2(take_action_cb, modification.external_id, b);
                            }), undefined, undefined, undefined, undefined, "c-mui-primary-next-btn", undefined, undefined),
                      key: Nanoid.nanoid()
                    }),
                tl: /* [] */0
              }
            });
      }
    } else {
      tmp = React.createElement(PrimaryButton$Catalyst.make, {
            buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                  TAG: /* Text */0,
                  _0: ModificationActions.toString(a)
                }, undefined, (function (param) {
                    return Curry._2(take_action_cb, modification.external_id, a);
                  }), undefined, undefined, undefined, undefined, "c-mui-primary-next-btn", undefined, undefined),
            key: Nanoid.nanoid()
          });
    }
  } else {
    tmp = null;
  }
  return React.createElement(ReactModal, {
              isOpen: true,
              onRequestClose: (function (param) {
                  
                }),
              overlayClassName: "modal-overlay",
              className: "modal-content modification-detail-modal-content",
              ariaHideApp: false,
              shouldCloseOnOverlayClick: false,
              children: React.createElement("div", {
                    className: "c-modification-detail-modal"
                  }, React.createElement(React.Fragment, undefined, React.createElement(Row$Catalyst.make, {
                            children: null,
                            className: "header"
                          }, React.createElement("div", {
                                className: "title"
                              }, modification.name), React.createElement("img", {
                                className: "close-btn",
                                src: close_icon,
                                onClick: (function (param) {
                                    return Curry._1(close_modal, undefined);
                                  })
                              })), React.createElement("div", {
                            className: "body"
                          }, React.createElement(VehicleGeoRegionTitleBar.make, {
                                vehicle_name: modification.vehicle_name,
                                geo_region: modification.region
                              }), React.createElement(CardComponent$Catalyst.make, {
                                className: "modification-basic-primary-info-card",
                                children: null
                              }, React.createElement(Row$Catalyst.make, {
                                    children: null
                                  }, React.createElement("div", undefined, "Status"), React.createElement("div", {
                                        className: ModificationStatusVm.toString(modification.status)
                                      }, ModificationStatusVm.toString(modification.status))), React.createElement(CorePricingViewUtils.LineItem.make, {
                                    label: "Created By",
                                    value: modification.created_by
                                  }), React.createElement(CorePricingViewUtils.LineItem.make, {
                                    label: "Created On",
                                    value: modification.created_on
                                  }), match$1 !== 1 ? React.createElement(React.Fragment, undefined, React.createElement("hr", {
                                          className: "separator"
                                        }), React.createElement(CorePricingViewUtils.LineItem.make, {
                                          label: "Approved By",
                                          value: modification.approved_by
                                        }), React.createElement(CorePricingViewUtils.LineItem.make, {
                                          label: "Approved On",
                                          value: modification.approved_on
                                        })) : null), React.createElement(CardComponent$Catalyst.make, {
                                className: "modification-basic-primary-info-card",
                                children: null
                              }, React.createElement(Row$Catalyst.make, {
                                    children: null
                                  }, React.createElement("div", undefined, "Parent Core Campaign"), React.createElement("div", {
                                        className: ""
                                      }, modification.core_pricing_name)), React.createElement(CorePricingViewUtils.LineItem.make, {
                                    label: "Start Date",
                                    unit: "dd/mm/yyyy",
                                    value: Timestamp$Catalyst.toString(modification.start_date, "DD/MM/yyyy")
                                  }), end_date !== undefined ? React.createElement(CorePricingViewUtils.LineItem.make, {
                                      label: "End Date",
                                      unit: "dd/mm/yyyy",
                                      value: Timestamp$Catalyst.toString(Caml_option.valFromOption(end_date), "DD/MM/yyyy")
                                    }) : null), React.createElement(ModificationDetailModal$BaseDetailsSection, {
                                base_details: modification.base_details
                              }), React.createElement(ModificationDetailModal$SlabDetailsSection, {
                                slabs: modification.slabs
                              }), React.createElement(EligibilityRulesCard.make, {
                                eligibility_rules: modification.eligibility_rules
                              })), React.createElement("div", {
                            className: "footer"
                          }, tmp)))
            });
}

var make = ModificationDetailModal;

export {
  close_icon ,
  convertIdListToRange ,
  testIdsToString ,
  getAccordionHeaderForTestSample ,
  BaseDetailsSection ,
  SlabDetailsSection ,
  make ,
  
}
/* close_icon Not a pure module */
